
function TypeFreeContent({ typeContent, chooseType }) {
    return (
        <div className="flex flex-row-reverse items-center justify-between mb-4">
            <p>  : دسته بندی</p>
            <select
                className="bg-white border border-slate-200 rounded p-1 w-9/12 drtl"
                value={typeContent}
                onChange={(e) => chooseType(e.target.value)}
            >
                <option value="01">علم و تکنولوژی</option>
                <option value="02">داستانی</option>
                <option value="03">روانشناسی</option>
                <option value="04">اقتصاد</option>
                <option value="05">مدیریت</option>
                <option value="06">اجتماعی</option>
                <option value="07">تاریخی</option>
                <option value="08">سلامت</option>
                <option value="09">فلسفه</option>
                <option value="10">موفقیت</option>
                <option value="11">زندگی نامه</option>
            </select>
        </div>
    )
}
export default TypeFreeContent;